import { render, staticRenderFns } from "./PlayerInformation.vue?vue&type=template&id=38fafaba"
import script from "./PlayerInformation.vue?vue&type=script&lang=js"
export * from "./PlayerInformation.vue?vue&type=script&lang=js"
import style0 from "./PlayerInformation.vue?vue&type=style&index=0&id=38fafaba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports